
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candidate/funnel-matches",
      function () {
        return require("private-next-pages/candidate/funnel-matches/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candidate/funnel-matches"])
      });
    }
  